import { ProviderPortalSentry } from '@vs/components/portal-sentry';
import { ProviderOidc } from '@vs/oidc-client';
import { ProviderSpaPathsConfig } from '@vs/shared-context/spa-path-config-provider';
import { TableActionStateProvider } from '@vs/shared-context/table-action-state-provider';
import { PortalBackdrop } from '@vs/ui/portal/backdrop';
import { ProviderEnv } from '@vs/utils/envConfig';
import { createI18n } from '@vs/utils/i18n';
import { ProviderMuiTheme } from '@vs/utils/mui';
import { I18nextProvider } from 'react-i18next';
import { Provider } from 'react-redux';
import { BrowserRouter } from 'react-router-dom';
import { PersistGate } from 'redux-persist/integration/react';

import {
  basePath,
  deployEnv,
  isLocalDevMode,
  localesFolderPath,
} from '../constants';
import { env } from '../constants/env';
import { oidcConfig } from '../constants/oidc';
import { pathsConfig } from '../constants/pathsConfig';
import { persistor, store } from '../redux/store';
import AppAuthRoutes from './appContent/AppAuthRoutes';

const i18n = createI18n({
  localesFolderPath,
  defaultNS: 'vs-account',
});

export default function App() {
  return (
    <ProviderEnv env={env}>
      <Provider store={store}>
        <ProviderMuiTheme>
          <ProviderOidc config={oidcConfig}>
            <ProviderPortalSentry
              enableSentry={!isLocalDevMode}
              sentryOptions={{ env: deployEnv }}
              dialogMode={isLocalDevMode ? 'detail' : 'compact'}
            >
              <BrowserRouter basename={basePath}>
                <I18nextProvider i18n={i18n}>
                  <PersistGate
                    loading={<PortalBackdrop type="app_init" open />}
                    persistor={persistor}
                  >
                    <ProviderSpaPathsConfig
                      configs={pathsConfig}
                      appNameI18nKey={'shared:header.app_subtitle.account'}
                    >
                      <TableActionStateProvider>
                        <AppAuthRoutes />
                      </TableActionStateProvider>
                    </ProviderSpaPathsConfig>
                  </PersistGate>
                </I18nextProvider>
              </BrowserRouter>
            </ProviderPortalSentry>
          </ProviderOidc>
        </ProviderMuiTheme>
      </Provider>
    </ProviderEnv>
  );
}
